<template>
	<div v-if="cabecalhoStatus" class="fl-cabecalho">
		<div class="row">
			<div class="col-lg-4 col-md-4 col-xs-12">
				<i class="icon icon-diario_bordo"></i>
				<h3>{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}</h3>
				<h4>{{ _traducao('global', 'pilotoECopiloto').toUpperCase() }}</h4>
			</div>

			<div class="col-xs-12 col-md-4 col-lg-4">
				<span v-if="formId == 0">
					<i class="icon icon-solicitacao_nova_solicitacao icon-sub"></i>
					<h3>{{ _traducao('global', 'preencher').toUpperCase() }}</h3>
				</span>

				<span v-if="formId != 0">
					<i class="icon icon-editar icon-sub"></i>
					<h3>{{ _traducao('global', 'editar').toUpperCase() }}</h3>
				</span>
				<h4>{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}</h4>
			</div>

			<div class="col-xs-12 col-md-4 col-lg-4">
				<button
					@click="$emit('volta-lista')"
					class="btn btn-default btn-lg btn-action"
					:title="_traducao('global', 'voltar')"
				>
					<i class="icon-left" style="font-size: 18px" aria-hidden="true"></i>
				</button>

				<button
					class="btn btn-default btn-lg btn-action"
					:title="_traducao('global', 'imprimir')"
					style="margin-right: 20px"
					@click="$emit('click-print')"
				>
					<i class="icon-imprimir" style="font-size: 18px"></i>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CabecalhoDbPiloto',

	props: {
		cabecalhoStatus: {
			type: Boolean,
			default: true,
			required: false
		},

		formId: {
			type: [String, Number],
			default: 0,
			required: false
		}
	}
}
</script>

<style scoped>
@media (min-width: 991px) {
	.btn-action {
		float: right;
	}
}
</style>